import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { ACCESS_TOKEN } from '../../../../commons/Const'
import { getParams, buildJoinQueryString, getStorage } from '../../../../commons/utils'

export default ComposedComponent => {
  class RedirectToQuiz extends React.Component {
    componentDidMount() {
      if (getStorage(ACCESS_TOKEN)) {
        this.props.pushToQuiz(getParams())
      }
    }

    render() {
      return <ComposedComponent />
    }
  }

  RedirectToQuiz.propTypes = {
    pushToQuiz: PropTypes.func.isRequired
  }

  const mapStateToProps = () => ({})

  const mapDispatchToProps = dispatch => ({
    pushToQuiz: data => dispatch(push(`/quiz?${buildJoinQueryString(data)}`))
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(RedirectToQuiz)
}
